import React from 'react';
import FavoriteModule from '../components/settings/FavoriteModule/Index';

// Encabezado unificado estilo "rk-head": icono azul + título + subtítulo,
// con acciones (Filtrar / Nuevo / favorito) alineadas a la derecha.
// Reemplaza a HeaderTitle en los índices de Riesgos, AMEF y Análisis de causa.
const RkHeader = ({
    icon = "fas fa-toolbox",
    title,
    subtitle,
    showNew, titleNew, onClickNew,
    showFilter, titleFilter, onClickFilter,
    is_index, url,
    children,
}) => (
    <div className="rk-head">
        <div className="rk-head__icon">
            <i className={icon}></i>
        </div>

        <div className="rk-head__text">
            <h2 className="rk-head__title">{title}</h2>
            {subtitle && <p className="rk-head__subtitle">{subtitle}</p>}
        </div>

        <div className="rk-head__actions">
            {is_index && (
                <FavoriteModule url={url} name={title} icon={icon} />
            )}

            {showFilter && (
                <button
                    type="button"
                    onClick={() => onClickFilter && onClickFilter()}
                    className="rk-head__btn rk-head__btn--ghost"
                >
                    <i className="fas fa-filter"></i> {titleFilter || "Filtros"}
                </button>
            )}

            {showNew && (
                <button
                    type="button"
                    onClick={() => onClickNew && onClickNew("new")}
                    className="rk-head__btn rk-head__btn--primary"
                >
                    <i className="fas fa-plus"></i> {titleNew || "Nuevo"}
                </button>
            )}

            {children}
        </div>
    </div>
);

export default RkHeader;
